import { CenterOlComment } from '../../../lib/types/models/center-ol-comment/center-ol-comment'
import { CenterOlCommentInput } from '../../../lib/types/models/center-ol-comment/center-ol-comment-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateCenterOlComment = async (
  data: UpdateInput<CenterOlCommentInput> & { centerId: number }
) => {
  const { id, centerId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterOlComment.url, { id, centerId }))
    .patch<CenterOlComment, Partial<CenterOlCommentInput>>(rest)
}
